module.exports = __webpack_public_path__ + "static/img/bandera_azul_logo_1.4065379e.jpg";